// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".q-field--with-bottom[data-v-0d020ebe]{padding-bottom:0}", ""]);
// Exports
module.exports = exports;
